import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import { getRouteByName } from 'Helpers/Routes';

import Gallery from 'Components/layout/Gallery';
import Button from 'Components/layout/Button';

import { fetchByTags as fetchRelatedPhotosByTags } from 'Redux/actions/relatedPhotos';

@connect(
    (state) => ({
        relatedPhotosMap: state.relatedPhotos,
    }), { fetchRelatedPhotosByTags }
)
export default class SinglePhotoRelatedPhotos extends React.Component {
    static propTypes = {
        fetchRelatedPhotosByTags: PropTypes.func.isRequired,
        onEnterPhoto: PropTypes.func,
        photo: PropTypes.shape({
            id: PropTypes.string.isRequired,
            user: PropTypes.shape({
                username: PropTypes.string.isRequired
            }).isRequired,
            selectedTagLinks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired
                })
            ).isRequired
        }).isRequired,
        relatedPhotosMap: PropTypes.arrayOf(
            PropTypes.shape({
                isPending: PropTypes.bool.isRequired,
                isLoaded: PropTypes.bool.isRequired,
                photoId: PropTypes.string.isRequired,
                tags: PropTypes.arrayOf(
                    PropTypes.string.isRequired
                ).isRequired,
                photos: PropTypes.arrayOf(
                    PropTypes.object
                )
            })
        ).isRequired
    };
    static defaultProps = {
        onEnterPhoto: () => false
    }

    state = {};

    componentDidMount = () => {
        const { photo, fetchRelatedPhotosByTags } = this.props;

        fetchRelatedPhotosByTags({
            photoId: photo.id,
            tags: photo.relatedTags
        });
    }

    render() {
        const { onEnterPhoto, photo, relatedPhotosMap } = this.props;
        const currentRelatedPhotosIndex = relatedPhotosMap.findIndex(relatedPhotos => relatedPhotos.photoId === photo.id);
        const relatedPhotosObject = relatedPhotosMap[currentRelatedPhotosIndex];

        if (!relatedPhotosObject) {
            //Dont render component if data hasnt start downloading yet
            return (null);
        } else if (relatedPhotosObject.isPending || !relatedPhotosObject.isLoaded || !relatedPhotosObject.photos.length) {
            //Dont render component if there are no related photos
            return (null);
        }

        return (
            <div className="component-single-photo-related-photos">
                <div className="container-fluid">
                    <h2 className="title">
                        {I18n.t('SINGLE_PHOTO.relatedPhotos.listTitle')}: {photo.relatedTags.join(', ')}
                    </h2>
                    <div className="gallery">
                        <Gallery
                            photos={relatedPhotosObject.photos}
                            onEnterAsync={onEnterPhoto}
                            overlayType="default"
                        />
                    </div>
                    <Button
                        element="anchor"
                        layout="wide"
                        href={getRouteByName('search', { query: encodeURI(photo.relatedTags.join(' ')) }).path}
                        rel="nofollow"
                    >
                        <span>{I18n.t('SINGLE_PHOTO.relatedPhotos.browseMore')}</span>
                    </Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/RelatedPhotos/index.js